import { apiSlice } from "app/api/apiSlice";

export const FPOApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFPOLeads: builder.query({
      query: ({ pagination, searchKey }) =>
        `/api/v1/onboarding/farmer-groups/FPO/leads?q=${searchKey}`,
    }),
    getFPOLeadsById: builder.query({
      query: (id) => `/api/v1/onboarding/farmer-groups/FPO/leads/${id}`,
    }),
    updateFPOLeadById: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/farmer-groups/FPO/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),
    getFPOList: builder.query({
      query: ({ pagination, searchKey, orgId }) =>
        `/api/v1/onboarding/farmer-groups/FPO?q=${searchKey}` +
        (orgId ? `&reporting_to_id=${orgId}` : ""),
      // +
      // (searchKey?` &q=${searchKey}`:""),
    }),
    getFPOById: builder.query({
      query: (id) => `/api/v1/onboarding/farmer-groups/FPO/${id}`,
    }),
    createFPO: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/onboarding/farmer-groups/FPO",
        method: "POST",
        body: payload,
      }),
    }),
    getFPOUserList: builder.query({
      query: (pagination) => `/api/v1/onboarding/farmer-groups/FPO_users`,
    }),
    createFPOUser: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/onboarding/farmer-groups/FPO_users",
        method: "POST",
        body: payload,
      }),
    }),
    takeActionFPO: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/farmer-groups/FPO/take_action/${id}`,
        method: "PUT",
        body: payload,
      }),
    }),
    getFPOallMediabyId: builder.query({
      query: (id) => `/api/v1/onboarding/farmer-groups/FPO/${id}/media`,
    }),
    getFPOprofileAnalyticsbyid: builder.query({
      query: (id) => `/api/v1/onboarding/farmer-groups/FPO/${id}/analytics`,
    }),
    getDashboardProfile: builder.query({
      query: () => `/api/v1/onboarding/organizations/dashboard`,
    }),
    // getDashboardProfilebyId: builder.query({
    //   query: (id) => `/api/v1/onboarding/organizations/dashboard/${id}`,
    // }),
    getDashboardProfilebyId: builder.query({
      query: (id) =>
        id
          ? `/api/v1/onboarding/organizations/dashboard/${id}`
          : `/api/v1/onboarding/organizations/dashboard`,
    }),

    getFpoOrganizationDocumentById: builder.query({
      query: (id) => `/api/v1/onboarding/organizations/${id}/media`,
    }),
    uploadFpoDocumentById: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/api/v1/onboarding/organizations/${id}/media`,
        method: "POST",
        body: formData,
      }),
    }),
    getManufacturerById: builder.query({
      query: ({ id, organization_type }) =>
        `/api/v1/onboarding/outputs/${(organization_type || "")
          .toLowerCase()
          .replace(" ", "-")}/${id}`,
    }),
    patchDocumentById: builder.mutation({
      query: ({ id, formSendData }) => ({
        url: `/api/v1/onboarding/organizations/${id}/media`,
        method: "PATCH",
        body: formSendData,
      }),
    }),
  }),
});

export const {
  useGetFPOLeadsQuery,
  useGetFPOLeadsByIdQuery,
  useUpdateFPOLeadByIdMutation,
  useGetFPOListQuery,
  useGetFPOByIdQuery,
  useCreateFPOMutation,
  useGetFPOUserListQuery,
  useCreateFPOUserMutation,
  useTakeActionFPOMutation,
  useGetFPOallMediabyIdQuery,
  useGetFPOprofileAnalyticsbyidQuery,
  useGetDashboardProfileQuery,
  useGetDashboardProfilebyIdQuery,
  useGetFpoOrganizationDocumentByIdQuery,
  useUploadFpoDocumentByIdMutation,
  useGetManufacturerByIdQuery,
  usePatchDocumentByIdMutation,
  useGetTradersByIdQuery,
} = FPOApiSlice;
